import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  main: {
    paddingLeft: 120,
    paddingTop: "25vh",
    color: "rgb(248, 244, 240)",
  },
  button: {
    marginTop: 20,
    marginRight: 25,
  },
  greeting: {
    marginTop: 80,
  },
});
